import SVGInject from '@iconfu/svg-inject'
import initializePickers from '../plugins/PluginPicker.ts'
import Popup from '../plugins/PluginPopup.ts'
import { initializePopupPlan } from './ComponentPopupPlan.ts'
import Choices from 'choices.js'
import tippy, { followCursor } from 'tippy.js'
import 'tippy.js/dist/tippy.css' // optional for styling

interface IItemData {
  id: string
  name: string
  map: string
  mask: string
  items: {
    id: string
    name: string
    access: string
    url: string
  }[]
}

const PATH = 'assets/img/maps'

// TODO: make picker attr lookup dynamic

window.addEventListener('load', () => {
  const selects2 = document.querySelectorAll(`[data-item="select-plan"]`)
  if (selects2.length > 0) {
    selects2.forEach((select) => {
      window.selectSpace = new Choices(select, {
        shouldSort: false,
        callbackOnCreateTemplates: function (template) {
          return {
            item: ({ classNames }: any, data: any) => {
              return template(`
                <div data-plan-option-seleted>
                  ${data.label}
                </div>
              `)
            },
            choice: ({ classNames }: any, data: any) => {
              return template(`
            <div class="${classNames.item} ${classNames.itemChoice} ${data.disabled
                  ? classNames.itemDisabled
                  : classNames.itemSelectable
                }" data-picker-option data-id="${data.id}" data-value="${data.value
                }">
              ${data.label}
            </div>
          `)
            },
          }
        },
      })
    })
  }
  setTimeout(() => {
    initializePickers({
      activeIndexes: [0],
      noSelected: false,
      activeClass: 'active',
      pickerSelector: '[data-picker="rent"]',
      multiplePickerSelector: '',
      buttonSelector: '[data-picker-option]',
      itemSelector: '[data-picker-item]',
    })
  }, 500)

  const planContainers = document.querySelectorAll('[data-plan]')

  if (planContainers.length === 0) return

  planContainers.forEach((planContainer) => {
    initializePlan(planContainer)
  })

  /* initialize picker after plan injection */
  initializePickers({
    activeIndexes: [0],
    noSelected: false,
    activeClass: 'active',
    pickerSelector: '[data-picker="rent"]',
    multiplePickerSelector: '',
    buttonSelector: '[data-plan-picker-btn]',
    itemSelector: '[data-picker-item]',
  })
})

const initializePlan = (container: Element) => {
  const planInfo = container.querySelector('[data-plan-info]')
  const planItem = container.querySelector('[data-plan-item]')

  const planData = planInfo?.getAttribute('data-plan-info')

  if (!planInfo || !planData || !planItem) return

  const planJSON: IItemData[] = JSON.parse(planData)

  Object.keys(planJSON).forEach((key, i) => {
    const itemNode = planItem.cloneNode(true) as Element
    /* remove template */
    planItem.remove()

    /* create clones of template */
    const clonedItem = planInfo.appendChild(itemNode)

    if (i !== 0) {
      clonedItem.classList.remove('active')
    }

    injectData(clonedItem, planJSON, key, i, container)
  })
}

const injectData = (
  item: Element,
  data: IItemData[],
  key: string,
  i: number,
  container: Element,
) => {
  const itemData = data?.[Number(key)]
  console.log(data)

  if (!itemData) return

  const planMap = item.querySelector('[data-plan-map]')
  const planMapMask = item.querySelector('[data-plan-map-mask]')
  // const planMapPopup = item.querySelector('[data-plan-popup]')

  // if (!planMap || !planMapMask || !planMapPopup) return
  if (!planMap || !planMapMask) return

  const staticMap = planMap.appendChild(document.createElement('img'))
  staticMap.src = `${itemData.map}`
  staticMap.alt = 'Static Map'

  const mask = planMapMask.appendChild(document.createElement('img'))
  mask.src = `${itemData.mask}`
  mask.alt = 'Map Mask'

  /* convert img to svg */
  SVGInject.setOptions({
    afterInject: () => {
      const paths = planMapMask.querySelectorAll('path')

      paths.forEach((path, index) => {

        path.setAttribute('data-popup-btn', '')
        data[parseFloat(key)]['items'][index] && path.setAttribute('data-id', data[parseFloat(key)]['items'][index].id)
        data[parseFloat(key)]['items'][index] && path.setAttribute('data-url', data[parseFloat(key)]['items'][index].url)
        if (data[parseFloat(key)]['items'][index]) {
          path.setAttribute('data-access', 'true')
          path.setAttribute('data-tippy-content', data[parseFloat(key)]['items'][index].access)
          path.setAttribute('data-tippy-interactive', "true")
        }
      })

      if (Object.keys(data).length - 1 === i) {
        /* initialize popup after plan injection */
        setTimeout(() => {
          getPopups(data, container)

          tippy('[data-access="true"]', {
            theme: 'dark',
            allowHTML: true,
            appendTo: planMapMask,
            trigger: 'mouseenter',
            interactive: true,
            arrow: true,
            placement: 'left-start',
            maxWidth: 'none',
            followCursor: true,
            plugins: [followCursor],
          })
        }, 200)
      }
    },
  })
  SVGInject(mask)
}

const getPopups = (data: IItemData[], planContainer: Element) => {
  // const planContainers = document.querySelectorAll('[data-plan]')

  // planContainers.forEach((planContainer, index) => {
  if (planContainer) {
    const popupBtns = planContainer.querySelectorAll(`[data-popup-btn]`)
    const template = document.querySelector(`[data-item="content-popup"]`)

    if (popupBtns.length === 0 || !template) return

    popupBtns.forEach((btn, i) => {
      new Popup({
        trigger: 'click',
        openBtn: btn,
        title: '',
        content: '',
        isTemplate: true,
        template: template,
        iconClose: false,
        btnClose: true,
        btnCloseContent: '',
        customClass: 'popup-rent',
        onAfterOpen() {
          const id = btn.getAttribute('data-id')
          const url = btn.getAttribute('data-url')
          const popup = document.querySelector(`[data-popup="true"]`)

          if (popup) {
            const content = popup.querySelector(`[data-popup="content"]`)

            if (url) {
              fetch(url, {
                method: 'get',
              })
                .then((res) => {
                  return res.text()
                })
                .then((data) => {
                  if (content) {
                    // Add new content
                    content.insertAdjacentHTML('afterbegin', data)

                    const svg = content.querySelectorAll(`[data-item="svg"]`)
                    SVGInject.setOptions({
                      afterInject: null,
                    })
                    SVGInject(svg)
                    // content.innerHTML = data

                    const scrollsContainer = popup.querySelector(
                      `[data-popup="wrapper"]`,
                    )
                    if (scrollsContainer) {
                      // scrollsContainers.forEach((container) => {
                      // Check if custom srcoll has ben alread init on this container
                      if (
                        scrollsContainer.getAttribute(
                          'data-custom-scroll-active',
                        ) != 'true'
                      ) {
                        scrollsContainer.setAttribute(
                          'data-custom-scroll-active',
                          'true',
                        )

                        new window.simplebar(scrollsContainer, {
                          autoHide: false,
                        })
                      }
                      // })
                    }

                    setTimeout(() => {
                      content.classList.remove('hidden')

                      const popupPlanContainers =
                        content.querySelector('[data-popup-plan]')

                      if (popupPlanContainers)
                        initializePopupPlan(popupPlanContainers)
                    }, 200)
                  }
                })
            }
          }
        },
      })
    })
  }
  // })
}
